// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"MainContainer_mainContainer__2pCUz","content":"MainContainer_content__1oJvv"};